import SelectEmailTemplateModal from './SelectEmailTemplateModal';

export default SelectEmailTemplateModal;
